import { KeyValue } from '../..'

export interface CinemaGuideTabBox {
    boxTitle: string
    content: { title: string; text: string }[]
}

export interface CinemaGuideTabExtension {
    tabTitle: string
    suppressOnB2B: boolean
    boxes: CinemaGuideTabBox[]
}

export const mapCinemaGuideTabs = (data: any[], attributesData: KeyValue[]): CinemaGuideTabExtension[] => {
    const result = data.map<CinemaGuideTabExtension>(e => e)

    return result
}
